import { createGlobalStyle } from 'styled-components';

export const MainContentStyled = createGlobalStyle`
	#mainContent {
		margin-top: 0;
		margin-bottom: 0;
	}
`;
